import { Collapse, CollapseProps, Image } from "antd";
import { useState } from "react";
import CareteDownIcon from "../../../assets/icons/CareteDownIcon";
import CaretUpIcon from "../../../assets/icons/CaretUpIcon";
import { GetGroupAttachmentsResponse } from "../../../types/mail";
import Loader from "../../ui/Loader";

const Badge = ({ count }: { count: number }) => (
  <span className="bg-[#D7DFE9] rounded-xl px-1 ">{count}</span>
);

type MediaGridProps = {
  imgs?: string[];
};

const MediaGrid = ({ imgs }: MediaGridProps) => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!imgs || imgs.length === 0) return null;

  return (
    <>
      {/* Hidden preview group for manual control */}
      <div className="flex flex-wrap gap-2 mt-2 mb-2">
        <Image.PreviewGroup
          preview={{
            visible,
            current: currentIndex,
            onVisibleChange: (vis) => setVisible(vis),
            onChange: (current) => setCurrentIndex(current),
          }}
        >
          {imgs.map((img, i) => (
            <Image
              key={i}
              src={img}
              width={80}
              height={80}
              style={{
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #cccccc",
                cursor: "pointer",
              }}
            />
          ))}
        </Image.PreviewGroup>
      </div>
    </>
  );
};

type Props = {
  isLoading?: boolean;
  data?: GetGroupAttachmentsResponse["data"];
};

export default function CollapseItems({ isLoading, data }: Props) {
  const [activeKey, setActiveKey] = useState<string[]>(["1"]);
  const handleCollapseChange = (keys: string[] | string) => {
    const updatedKeys = Array.isArray(keys) ? keys : [keys];
    setActiveKey(updatedKeys);
  };

  const isActive = activeKey.includes("1");

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <div className="flex justify-between items-center">
          <span>Media</span>
          <div className="flex gap-2 items-center">
            <div className="text-[11px]">
              <Badge count={data?.media?.count || 0} />
            </div>
            {isActive ? <CaretUpIcon /> : <CareteDownIcon />}
          </div>
        </div>
      ),
      children: <MediaGrid imgs={data?.media?.links} />,
    },
  ];

  if (isLoading) {
    return <Loader />;
  }
  return (
    <Collapse
      className="sharedFiles"
      items={items}
      activeKey={activeKey}
      onChange={handleCollapseChange}
    />
  );
}
